'use strict';

const LoginService = function ($location, AnalyticsService, IdentityService, IntercomService, RavenService, RoutingUtil) {

  this.authSuccess = (res) => {

    const data = res.data;
    const orgs = data.user.organizations;
    const orgId = data.stateParams && data.stateParams.orgId;

    IdentityService.set('user', data.user);
    IdentityService.set('groups', data.groups);
    IdentityService.set('currentGroup', data.currentGroup);
    IdentityService.set('currentGroupAccess', data.currentGroupAccess);
    IdentityService.set('firebase', data.firebase);

    AnalyticsService.reIdentify();
    IntercomService.boot();
    RavenService.syncUser();

    if (!res.location) {
      res.location = '';
    }
    if ($location.absUrl().split('?')[1]) {
      res.location += '?' + $location.absUrl().split('?')[1];
    }

    if (orgId) {
      // parse the diorg from the QS
      const autoOrg = orgs.find((org) => {

        return org.id == orgId;
      });

      IntercomService.update({ 'Core_Last_Organization_Name': autoOrg.name }); // records this in intercom
      IntercomService.update({ 'Core_Last_Organization_Id': autoOrg.id }); // records this in intercom

      const payload = {
        email: data.user.email,
        organization: autoOrg
      };

      sbAuth.setOrganization(payload, null, null)
      .then(() => {

        RoutingUtil.sendToDestination(res.location);
      });
    }
    // redirect user to organization selection page if they have multiple orgs
    else if (orgs.length > 1) {
      RoutingUtil.redirectTo('select-organization');
    }
    else {
      IdentityService.set('currentOrganization', orgs[0]);

      IntercomService.update({ 'Core_Last_Organization_Name': orgs[0].name }); // records this in intercom
      IntercomService.update({ 'Core_Last_Organization_Id': orgs[0].id }); // records this in intercom

      RoutingUtil.sendToDestination();
    }
  };
};

LoginService.$inject = [
  '$location', 'AnalyticsService', 'IdentityService', 'IntercomService', 'RavenService', 'RoutingUtil'
];

module.exports = LoginService;



// WEBPACK FOOTER //
// ./src/app/login/LoginService.js